export default "__VITE_ASSET__B82mGCqO__"